import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

export const chartSeriesHasData = (chartSeries: ExtendedSeriesOptionsType[] | undefined) =>
  Array.isArray(chartSeries) &&
  chartSeries.some(series => Array.isArray(series?.data) && series.data.length > 0);
